var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWildlife = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.04 1.04C35.026.472 34.568.014 34 0c-.271 0-.53.11-.717.308-.187.196-.284.461-.27.732 0 2.48.294 9.493.374 11.92.007.546-.141 1.082-.427 1.547-.72 1.146-2.133 3.413-2.907 4.613-1.386 2.16-3.12 1.6-5.626.907-2.507-.694-2.32-2-2.667-4.427-.427-2.907-.933-8.267-1.547-13.147 0-.259-.104-.507-.29-.688-.186-.18-.437-.279-.696-.272-.556.096-.934.616-.854 1.174-.186 4.853-.426 10.133-.533 12.96 0 2.346-.747 3.333-2.667 3.306-.892.007-1.784-.055-2.666-.186-1.319-.064-2.422-1.023-2.667-2.32-.4-2.134-1.387-8.747-1.387-8.747 0-.667-.56-1.04-1.013-.96-.453.08-.72.587-.72 1.04 0 2.667.16 5.813.187 7.44 0 2.667-.8 2.96-2.667 2.667-1-.154-1.769-.967-1.867-1.974-.213-.906-.426-1.68-.666-3.013 0-.667-.587-.907-.934-.88-.393.032-.713.33-.773.72v2.667c-.02 3.325 2.573 6.082 5.893 6.266l16.907 3.12c1.404.21 2.65 1.017 3.413 2.214.726 1.422.96 3.044.667 4.613l-.24 1.147 5.627 1.92c.944-2.002 1.242-4.248.853-6.427 0-.4-.293-1.333-.56-2.667-.175-1.313.097-2.647.773-3.786l3.627-6.694c.325-.525.457-1.147.373-1.76-.533-2.506-1.76-9.626-2.293-12.293z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWildlife, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wildlife.1da7670c.svg";
export { ForwardRef as ReactComponent };